module.exports = __webpack_public_path__ + "img/calendar.6d5f9edd.svg";